__turbopack_context__.v({
  "input": "Input-module__1lEAvW__input",
  "inputDisabled": "Input-module__1lEAvW__inputDisabled",
  "inputError": "Input-module__1lEAvW__inputError",
  "inputIcon": "Input-module__1lEAvW__inputIcon",
  "inputInvertColor": "Input-module__1lEAvW__inputInvertColor",
  "inputLabel": "Input-module__1lEAvW__inputLabel",
  "inputWrap": "Input-module__1lEAvW__inputWrap",
});
